import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import * as AuthServices from "./Authorizationservice.js";
import authData from "./authData.json";
import {
  Dialog,
  DialogActionsBar,
  Window,
} from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import "./Authorization.scss";
import { process, filterBy } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
import $, { event } from "jquery";
import { Link } from "react-router-dom";
import qs from "qs";
import {NumericFormat} from "react-number-format";
import { Checkbox } from "@progress/kendo-react-inputs";
import DetailDialog from "./DetailDialog.jsx";
import { withRouter } from "../NCRMSHome/withRouter";

const dataState = {
  sort: [{ field: "freightOrder", dir: "desc" }],
  take: 50,
  skip: 0,
};

class Authorization extends React.Component {
  constructor(props) {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - 90);

    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    super(props);
    this.state = {
      authData: [],
      dataState: dataState,
      documentData: [],
      segmentsData: [],
      selectDocType: [
        { docType: "ZSSB", text: "Intel Shipment Request" },
        { docType: "ZMSB", text: "Multi Bid Request" },
        { docType: "ZEXC", text: "Invoice Adjustment Request " },
      ],
      buttonClicked: "",
      tor_id: "",
      foStatus: "",
      SCAC: "",
      gridData: [],
      selectedFreightOrderFromDate: startDate,
      selectedFreightOrderToDate: endDate,
      selectedSegment: [],
      blocking: false,
      all_submitted_records: false,
      filter: [],
      invoiceVisibleDialog: false,
      dialogRequestIDNum: null,
    };
  }

  toggleDialog = () => {
    this.setState({
      invoiceVisibleDialog: !this.state.invoiceVisibleDialog,
    });
    if (this.state.dialogRequestIDNum !== null) {
      console.log("dialogRequestIDNum");
      console.log(this.state.dialogRequestIDNum);
    }
  };

  handleChangeAllSubRec = () => {
    this.setState((_state) => ({
      ..._state,
      all_submitted_records: !_state.all_submitted_records,
    }));
  };

  getDocTypeData() {
    var docTypeArray = [];
    var docTypeObj = {};
    docTypeObj["docType"] = "ZSSB";
    docTypeObj["text"] = "Intel Shipment Request";
    docTypeArray.push(docTypeObj);
    docTypeObj = {};
    docTypeObj["docType"] = "ZMSB";
    docTypeObj["text"] = "Multi-Bid Request";
    docTypeArray.push(docTypeObj);
    docTypeObj = {};
    docTypeObj["docType"] = "ZEXC";
    docTypeObj["text"] = "Invoice Adjustment Request";
    docTypeArray.push(docTypeObj);
    this.setState({ documentData: docTypeArray });
  }

  async getSegmentData() {
    const response = await AuthServices.getSegments();
    this.setState({ segmentsData: response });
    this.setState({ blocking: false });
    this.getWorklistData();
  }

  approveDocument(dataItem, e) {
    this.setState({
      buttonClicked: "Approved",
      tor_id: dataItem.dataItem.freightOrder,
      foStatus: dataItem.dataItem.status,
    });
    $("#myModal").show();
  }

  rejectDocument(dataItem, e) {
    this.setState({
      buttonClicked: "Rejected",
      tor_id: dataItem.dataItem.freightOrder,
      foStatus: dataItem.dataItem.status,
    });
    $("#myModal").show();
  }

  sendBackDocument(dataItem, e) {
    this.setState({
      buttonClicked: "sendBack",
      tor_id: dataItem.dataItem.freightOrder,
      foStatus: dataItem.dataItem.status,
    });
    $("#myModal").show();
  }

  async convertToMulibid(dataItem, e) {
    var FOObj = {};
    FOObj["TOR_ID"] = dataItem.dataItem.freightOrder;
    const response = await AuthServices.convertToMultiBid(FOObj);
    if (response.STATUS == "SUCCESS") {
      const jsonResponse = await AuthServices.FOConvertToMultiBid(FOObj);
      if (jsonResponse.STATUS == "SUCCESS") {
        toast.success("Request converted to Multibid successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });

        this.getWorklistData();
      } else {
        toast.error(jsonResponse, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      }
    } else {
      toast.error(response, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
    }
  }

  fromDateHandleChange() {}

  async getAuthWorkListData(input) {
    var response = [];
    //  const authResponse = await AuthServices.getWorkListData(input);
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "Q_AUTH_WLIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const authResponse = await GatewayGet(props, props.input);
    if (authResponse !=undefined && authResponse.status == "SUCCESS") {
      response = authResponse.outputData;
      for (var i = 0; i < response.length; i++) {
        response[i].freightOrder = response[i].freightOrder.replace(/^0+/, "");
        response[i].rfqNumber = response[i].rfqNumber.replace(/^0+/, "");
      }
      this.setState({ gridData: response });
      console.log(this.state.gridData);

      this.setState({ blocking: false });
    } else {
      this.setState({ gridData: [] });
      this.setState({ blocking: false });
    }
  }

  textAreaChange = (event) => {
    this.setState({
      commentsValue: event.target.value,
    });
  };

  async getWorklistData() {
    this.setState({ blocking: true });

    var docTypeArray = [];
    var selectedSegmentData = [];
    //  this.getUserDetails();
    let profile = JSON.parse(sessionStorage.getItem("profile"));

    // On link click profile is null
    // we call the api again here
    if (!profile) {
      let props = {};
      let inputObj = {};
      props["query"] = constants.serviceRoot;
      props["headers"] = constants.serviceHeaders;
      inputObj["Activity"] = "GET_USER_DETAILS";
      inputObj["Input"] = "";
      props.input = inputObj;

      const userprofile = await GatewayGet(props, props.input);
      profile = userprofile["RESULT"];
    }
    this.setState({ user_id: profile.USER_ID });

    if (
      this.state.selectDocType == undefined ||
      this.state.selectDocType == null ||
      this.state.selectDocType == ""
    ) {
      // angular.element('.docTypeClass').addClass('mandatoryClass');
      toast.error("Doc Type is Mandatory", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ blocking: false });
      return;
    } else {
      // angular.element('.docTypeClass').removeClass('mandatoryClass');

      for (var i = 0; i < this.state.selectDocType.length; i++) {
        docTypeArray.push(this.state.selectDocType[i].docType);
      }
    }

    if (
      this.state.selectedFreightOrderFromDate == undefined ||
      this.state.selectedFreightOrderFromDate == null ||
      this.state.selectedFreightOrderFromDate == ""
    ) {
      // angular.element('.freightOrderFromDateClass').addClass('mandatoryClass');

      toast.error("Freight Order Created Date From is Mandatory", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ blocking: false });
      return;
    }

    if (
      this.state.selectedFreightOrderNumberTo != undefined &&
      this.state.selectedFreightOrderNumberTo != null &&
      this.state.selectedFreightOrderNumberTo != ""
    ) {
      if (
        this.state.selectedFreightOrderNumberFrom != undefined &&
        this.state.selectedFreightOrderNumberFrom != null &&
        this.state.selectedFreightOrderNumberFrom
      ) {
        if (
          parseInt(this.state.selectedFreightOrderNumberFrom, 10) >
          parseInt(this.state.selectedFreightOrderNumberTo, 10)
        ) {
          // angular.element('.foNumberFromClass').addClass('mandatoryClass');

          toast.error("Freight Order From is greater than Freight Order To", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          this.setState({ blocking: false });
          return;
        }
      } else {
        // angular.element('.foNumberFromClass').addClass('mandatoryClass');

        toast.error(
          "Freight Order From is mandatory when Freight Order To is selected",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );
        this.setState({ blocking: false });
        return;
      }
    }

    var formattedFreightOrderFromDate = "";
    if (
      this.state.selectedFreightOrderFromDate != null &&
      this.state.selectedFreightOrderFromDate != undefined &&
      this.state.selectedFreightOrderFromDate != ""
    ) {
      var d = new Date(this.state.selectedFreightOrderFromDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderFromDate = [year, month, day].join("");
    }

    var formattedFreightOrderToDate = "";
    if (
      this.state.selectedFreightOrderToDate != null &&
      this.state.selectedFreightOrderToDate != undefined &&
      this.state.selectedFreightOrderToDate != ""
    ) {
      var d = new Date(this.state.selectedFreightOrderToDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderToDate = [year, month, day].join("");
    }

    if (
      formattedFreightOrderToDate != undefined &&
      formattedFreightOrderToDate != null &&
      formattedFreightOrderToDate != ""
    ) {
      if (
        formattedFreightOrderFromDate != undefined &&
        formattedFreightOrderFromDate != null &&
        formattedFreightOrderFromDate != ""
      ) {
        if (
          parseInt(formattedFreightOrderFromDate, 10) >
          parseInt(formattedFreightOrderToDate, 10)
        ) {
          // angular.element('.freightOrderFromDateClass').addClass('mandatoryClass');

          toast.error(
            "FO Created From Date is greater than FO Created To Date",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            }
          );
          this.setState({ blocking: false });
          return;
        }
      }
    }
    if (this.state.selectedSegment.length > 0) {
      for (var j = 0; j < this.state.selectedSegment.length; j++) {
        selectedSegmentData.push(this.state.selectedSegment[j].text);
      }
    }

    var input = {};
    input["tor_type"] = docTypeArray;
    input["fo_number_from"] = this.state.selectedFreightOrderNumberFrom;
    input["fo_number_to"] = this.state.selectedFreightOrderNumberTo;
    input["createddate_start"] = formattedFreightOrderFromDate;
    input["createddate_end"] = formattedFreightOrderToDate;
    if (this.state.all_submitted_records === true) {
      input["all_auth_user"] = "X";
    }

    input["segment_id"] = selectedSegmentData;

    input["to_be_authorized_by"] = this.state.user_id;
    const tor_key = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).torID;
    if (typeof tor_key !== "undefined" && tor_key) {
      input["tor_key"] = tor_key;
    }

    this.getAuthWorkListData(input);
  }

  closeWindow() {
    $("#myModal").hide();
  }

  closeDialog() {
    $("#myModal").hide();
  }

  async sendBackDocuments(input) {
    const response = await AuthServices.FOSentBack(input);
    if (response.STATUS == "SUCCESS") {
      if (this.state.buttonClicked == "Approved") {
        toast.success("Invoice Authorization Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else if (this.state.buttonClicked == "Rejected") {
        toast.success("Invoice Rejection Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else {
        toast.success("Invoice Sent Back Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      }
    } else {
      if (this.state.buttonClicked == "Approved") {
        toast.error("Invoice Authorization Failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else if (this.state.buttonClicked == "Rejected") {
        toast.error("Invoice Rejection Failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else {
        toast.error("Invoice Sent Back Failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      }
    }
  }

  async RejectDocuments(input) {
    const response = await AuthServices.FOReject(input);
    if (this.state.buttonClicked == "sendBack") {
      if (response.STATUS == "SUCCESS") {
        toast.success("Request SentBack Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else {
        toast.error(response + "Request SentBack failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      }
    } else {
      if (response.STATUS == "SUCCESS") {
        toast.success("Request Rejection Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      } else {
        toast.error(response + "Request Rejection failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.getWorklistData();
      }
    }
  }

  async ApproveDocuments(input) {
    const response = await AuthServices.FOAuthorize(input);
    if (response.STATUS == "SUCCESS") {
      toast.success("Request Authorization Successful", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.getWorklistData();
    } else {
      toast.error(
        "Request Authorization failed." + response.MESSAGE[1].MESSAGE,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        }
      );
      this.getWorklistData();
    }
  }

  searchFOData() {
    this.getWorklistData();
    // var grid = $("#kendoGrid").data("kendoGrid");
    // var models = grid.dataSource.data();
  }

  resetData() {
    this.setState({
      selectDocType: [],
      selectedSegment: [],
      selectedFreightOrderNumberFrom: "",
      selectedFreightOrderNumberTo: "",
    });
  }

  handleDocTypeChange = (event) => {
    this.setState({
      selectDocType: event.target.value,
    });
  };

  handleSegmentChange = (event) => {
    this.setState({
      selectedSegment: event.target.value,
    });
  };

  handleRequestIDFromChange = (event) => {
    this.setState({
      selectedFreightOrderNumberFrom: event.target.value,
    });
  };

  handleRequestIDToChange = (event) => {
    this.setState({
      selectedFreightOrderNumberTo: event.target.value,
    });
  };

  fromDateHandleChange = (event) => {
    this.setState({
      selectedFreightOrderFromDate: event.value,
    });
  };

  toDateHandleChange = (event) => {
    this.setState({
      selectedFreightOrderToDate: event.value,
    });
  };

  okClick() {
    $("#myModal").hide();
    this.setState({ blocking: true });
    var FOObj = {};

    if (this.state.buttonClicked == "sendBack") {
      if (parseInt(this.state.foStatus) == 20) {
        var inputObj = {};
        inputObj["tor_id"] = this.state.tor_id;
        inputObj["remarks"] = this.state.commentsValue;
        inputObj["action"] = "S";
        this.RejectDocuments(inputObj);
      } else {
        var inputObj = {};
        inputObj["torid"] = this.state.tor_id;

        inputObj["remarks"] = this.state.commentsValue;
        inputObj["status"] = "S";

        this.sendBackDocuments(inputObj);
      }
    } else if (this.state.buttonClicked == "Rejected") {
      if (
        parseInt(this.state.foStatus) == 71 ||
        parseInt(this.state.foStatus) == 77
      ) {
        var inputObj = {};
        inputObj["torid"] = this.state.tor_id;

        inputObj["remarks"] = this.state.commentsValue;
        inputObj["status"] = "R";
        this.sendBackDocuments(inputObj);
      } else {
        FOObj["tor_id"] = this.state.tor_id;
        FOObj["remarks"] = this.state.commentsValue;
        FOObj["action"] = "R";
        this.RejectDocuments(FOObj);
      }
    } else if (this.state.buttonClicked == "Approved") {
      if (
        parseInt(this.state.foStatus) == 71 ||
        parseInt(this.state.foStatus) == 77
      ) {
        var inputObj = {};
        inputObj["torid"] = this.state.tor_id;

        inputObj["remarks"] = this.state.commentsValue;
        inputObj["status"] = "A";
        this.sendBackDocuments(inputObj);
      } else {
        FOObj["TOR_ID"] = this.state.tor_id;
        FOObj["remarks"] = this.state.commentsValue;
        this.ApproveDocuments(FOObj);
      }
    }

    this.setState({ commentsValue: "" });
    // this.getWorklistData();
  }

  async getUserDetails() {
    const userData = await AuthServices.getUserDetails();
    const result = userData["RESULT"];
    this.setState({ user_id: result["USER_ID"] });
  }

  componentDidMount() {
    // If the user redirects from email links
    // Parse the url and get tor_key and fo type and do api call
    const FOType = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).FOType;

    if (typeof FOType !== "undefined") {
      if (FOType === "SingleBid") {
        this.setState({
          selectDocType: [{ docType: "ZSSB", text: "Intel Shipment Request" }],
        });
      } else if (FOType === "MultiBid") {
        this.setState({
          selectDocType: [{ docType: "ZMSB", text: "Multi Bid Request" }],
        });
      } else if (FOType === "InvAdj") {
        this.setState({
          selectDocType: [
            { docType: "ZEXC", text: "Invoice Adjustment Request " },
          ],
        });
      }
    }
    this.setState({ blocking: true });
    $("#myModal").hide();

    this.getDocTypeData();
    this.getSegmentData();
  }
  onButtonClick(e) {
   //console.log(e)
    this.props.navigate('/intelshipment',{ state: {authData:e}})
 
  }
  render() {
    const grid = (
      <Grid
        pageable={true}
        ScrollMode="scrollable"
        style={{ height: "600px", width: 'auto'}}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        {...this.state.dataState}
        filterable={true}
        filter={this.state.filter}
        onFilterChange={(e) => {
          this.setState({
            filter: e.filter,
          });
        }}
        data={process(
          filterBy(this.state.gridData, this.state.filter),
          this.state.dataState
        )}
      >
        <GridColumn
          locked={true}
          field="freightOrder"
          title="Request ID Number"
          width="150px"
          cell={(props) => (
            <td
              className="k-grid-content-sticky"
              role="gridcell"
              aria-colindex="1"
              style={{ left: "0px", right: "0px",cursor:"pointer",color:"#6495ed" }} onClick={() => this.onButtonClick(props.dataItem)}
            >
              
                {props.dataItem.freightOrder}
              
            </td>
          )}
        />

        <GridColumn
          locked={true}
          field="docTypeDesc"
          title="Document Type"
          width="150px"
        />
        <GridColumn
          locked={true}
          title="Additional Details"
          width="150px"
          cell={(props) => (
            <td
              className="k-grid-content-sticky"
              role="gridcell"
              aria-colindex="1"
              style={{ left: "300px", right: "0px" }}
            >
              {/* <NumberFormat
                value={Number(props.dataItem.totalAmount)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              /> */}
              <button
                className="btn k-button k-button-icontext appbtn"
                onClick={() => {
                  this.setState({ dialogRequestIDNum: props.dataItem }, () => {
                    this.toggleDialog();
                  });
                }}
              >
                Details
              </button>
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="toBeAuthorizedBy"
          title="To Be Authorized By"
          width="150px"
        />
        <GridColumn field="statusDesc" title="Request Status" width="150px" />

        <GridColumn field="carrierScac" title="SCAC" width="100px"></GridColumn>
        <GridColumn field="hawb" title="HAWB Number" width="150px"></GridColumn>
        <GridColumn
          field="sourceLocdesc"
          title="Source/Ship From"
          width="250px"
        ></GridColumn>
        <GridColumn
          field="destLocdesc"
          title="Destination/Ship To"
          width="250px"
        ></GridColumn>
        <GridColumn
          field="chargeAmt"
          title="Non-Contracted Bid Amount"
          width="230px"
          cell={(props) => (
            <td>
              <NumericFormat
                value={Number(props.dataItem.chargeAmt)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              />
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="invoiceAmt"
          title="Non-Contracted Invoice Amount"
          width="250px"
          cell={(props) => (
            <td>
              <NumericFormat
                value={Number(props.dataItem.invoiceAmt)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              />
            </td>
          )}
        ></GridColumn>
        <GridColumn
          width="550px"
          title="Action"
          cell={(props) => (
            <td>
              <div className="evnbtns">
                <button
                  className="btn k-button k-button-icontext appbtn"
                  onClick={this.approveDocument.bind(this, props)}
                >
                  Authorize
                </button>
                <button
                  className="btn k-button k-button-icontext  rejectbtn"
                  onClick={this.rejectDocument.bind(this, props)}
                >
                  Reject
                </button>
                {(props.dataItem.status == "71" ||
                  props.dataItem.status == "77" ||
                  props.dataItem.status == "20") && (
                  <button
                    className="btn k-button k-button-icontext reset"
                    onClick={this.sendBackDocument.bind(this, props)}
                  >
                    Send Back
                  </button>
                )}

                {props.dataItem.status == "20" &&
                  props.dataItem.docType == "ZSSB" && (
                    <button
                      className="btn k-button k-button-icontext reset"
                      onClick={this.convertToMulibid.bind(this, props)}
                    >
                      Convert To Multibid
                    </button>
                  )}
              </div>
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="createdOn"
          title="Request Created Date"
          width="200px"
        ></GridColumn>
        <GridColumn
          field="requestCreatedBy"
          title="Request Created By"
          width="200px"
        ></GridColumn>
        <GridColumn field="pro" title="PRO Number" width="150px"></GridColumn>
        <GridColumn
          field="currencyCode"
          title="Currency"
          width="120px"
        ></GridColumn>

        {/* <GridColumn field="carrierId" title="Carrier"  width="150px"></GridColumn>
             
             
             <GridColumn field="segment" title="Segment"  width="120px"></GridColumn>
             <GridColumn field="tendMgr" title="Tendering Manager"  width="200px"></GridColumn>
             <GridColumn field="remarks" title="Remarks"  width="300px"></GridColumn> */}
      </Grid>
    );

    return (
      <div >
        <div className="authorization-div">
        {this.state.invoiceVisibleDialog &&
          this.state.dialogRequestIDNum !== null && (
            <Dialog title={"Additional Details"} onClose={this.toggleDialog}>
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                <DetailDialog
                  detailDialogData={
                    this.state.dialogRequestIDNum !== null
                      ? this.state.dialogRequestIDNum
                      : {}
                  }
                  gridData={this.state.gridData}
                ></DetailDialog>
              </p>

              {/* <DialogActionsBar>
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={this.toggleDialog}
              >
                No
              </button>
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={this.toggleDialog}
              >
                Yes
              </button>
            </DialogActionsBar> */}
            </Dialog>
          )}

        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={
            <Circles
                  color="#00BFFF"
                  height="100"
                  width="100"
                  timeout="6000" //3 secs
                />
          }
        >
          <div>
            {/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/> */}
            {/* Same as */}
            {/* <ToastContainer /> */}
          </div>

          <MDBContainer fluid>
            <MDBRow>
              <MDBCol sm="12" className="titleBox">
                <label style={{ textAlign: "center" }}>
                  NCRM Authorization
                </label>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <MDBContainer fluid>
            <div className="cnt contentborderTab">
            <MDBRow>
                <MDBCol md="2">
                  <label>
                    Document Type <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol>
                  <MultiSelect
                    data={this.state.documentData}
                    value={this.state.selectDocType}
                    dataItemKey="docType"
                    textField="text"
                    onChange={this.handleDocTypeChange}
                  ></MultiSelect>
                </MDBCol>
                <MDBCol md="1">
                  <label>Segment</label>
                </MDBCol>
                <MDBCol>
                  <MultiSelect
                    data={this.state.segmentsData}
                    value={this.state.selectedSegment}
                    dataItemKey="value"
                    textField="text"
                    onChange={this.handleSegmentChange}
                  ></MultiSelect>
                </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="2">
                <label>Request ID From</label>
              </MDBCol>
              <MDBCol>
                <input
                  type="number"
                  className="form-control"
                  value={this.state.selectedFreightOrderNumberFrom}
                  onChange={this.handleRequestIDFromChange}
                ></input>
              </MDBCol>
              <MDBCol md="1">
                <label>To</label>
              </MDBCol>
              <MDBCol>
                <input
                  type="number"
                  className="form-control"
                  value={this.state.selectedFreightOrderNumberTo}
                  onChange={this.handleRequestIDToChange}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="2">
                <label>
                  Request ID Created From <em>*</em>
                </label>
              </MDBCol>
              <MDBCol>
                <DatePicker
                  value={this.state.selectedFreightOrderFromDate}
                  onChange={this.fromDateHandleChange}
                ></DatePicker>
              </MDBCol>
              <MDBCol md="1">
                <label>To</label>
              </MDBCol>
              <MDBCol>
                <DatePicker
                  value={this.state.selectedFreightOrderToDate}
                  onChange={this.toDateHandleChange}
                ></DatePicker>
              </MDBCol>
            </MDBRow>
            <MDBRow>
            <MDBCol md="2">
                <label style={{marginTop: "21px"}}>All NCRMs Awaiting Authorizations</label>
              </MDBCol>
              <MDBCol>
                <Checkbox 
                style={{marginTop: "21px", marginLeft: "1px"}}
                 // label={"All NCRMs Awaiting Authorizations"}
                  onChange={this.handleChangeAllSubRec}
                  value={this.state.all_submitted_records}
                />
              </MDBCol>
            </MDBRow>
            <br />

            {/* <MDBRow>
                    <MDBCol md='2'><label>Approval Status *</label></MDBCol>
                    <MDBCol ><input type = "checkbox" id = "awaitingApproval" checked = {this.state.awaitingApprovalChecked} onChange= {this.awaitingApprlChange}></input><label>Awaiting Approval</label></MDBCol>
                    <MDBCol ><input type = "checkbox" id = "approved" checked = {this.state.approvedChecked} onChange= {this.ApprovedChange}></input><label>Approved</label></MDBCol>
                    <MDBCol ><input type = "checkbox" id = "rejected" checked = {this.state.rejectedChecked} onChange= {this.RejectedChange}></input><label>Rejected</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "awaitingInvoiceApproval"  checked= {this.state.invApprovalChecked} onChange= {this.invoiceApprlChange}></input><label>Awaiting Invoice Approval</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "invoiceApproved" checked = {this.state.invApprovedChecked} onChange= {this.invoiceApprovedChange}></input><label>Invoice Approved</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "invoiceRejected" checked = {this.state.invRejectedChecked} onChange= {this.invoiceRejectedChange}></input><label>Invoice Rejected</label></MDBCol>
                </MDBRow> */}

            {/* <MDBRow>
                    <MDBCol sm="1">
                    <button type="submit" className="btn k-button k-button-icontext">Search</button>
               
                     
                    </MDBCol>
                    <MDBCol sm = "1">
                        <button className="btn btn-default reset">Reset</button>
                    </MDBCol>
                </MDBRow> */}
            <br></br>
            <MDBRow>
              <MDBCol>
                <p className="btnalign">
                  <button
                    type="submit"
                    onClick={this.searchFOData.bind(this)}
                    className="btn k-button k-button-icontext mt"
                  >
                    Search
                  </button>
                  <button
                    type="submit"
                    className="btn k-button k-button-icontext reset"
                    onClick={this.resetData.bind(this)}
                  >
                    Reset
                  </button>
                </p>
              </MDBCol>
            </MDBRow>
            </div>
            <div className="cnt contentGridTab">
              <MDBRow>
                <div className="cnt w-auto" id="kendoGrid">
                  {grid}
                </div>
              </MDBRow>
            </div>
          </MDBContainer>

          {/* <MDBContainer fluid>
            <MDBRow>
              <div className="cnt contentborderTab" id="kendoGrid">
                {grid}
              </div>
            </MDBRow>
          </MDBContainer> */}

          <div className="modals" id="myModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="headerTitle">Required Confirmation</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeWindow}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form className="k-form">
                  <fieldset>
                    <legend></legend>

                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="2">
                          <label>Comments </label>
                        </MDBCol>
                        <MDBCol>
                          <textarea
                            value={this.state.commentsValue}
                            onChange={this.textAreaChange.bind(this)}
                          ></textarea>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </fieldset>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  style={{marginBottom: "10px"}}
                  className="btn k-button k-button-icontext"
                  onClick={this.okClick.bind(this)}
                >
                  OK
                </button>
                <button
                  type="button"
                  style={{marginLeft: "10px", marginBottom: "10px"}}
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={this.closeDialog}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </BlockUi>
        </div>
      </div>
    );
  }
}

export default withRouter(Authorization);
